<template>
  <div>
    <b-row>
      <b-col>
        <p>
          Bij {{skin.region}} proberen wij het vinden van een passende woning zo gemakkelijk mogelijk te maken.
          U kunt daar zelf bij helpen door uw woonwensen hier zo duidelijk mogelijk aan te geven.
          De woningen die passen bij uw woonwensen staan dan altijd bovenaan.
        </p>
        <br/>
      </b-col>
    </b-row>
    <form-loader v-if="loading"/>
    <template v-if="!loading">
      <h2 class="subtitle">Mijn woonwensen</h2>
      <b-row class="multiselect-row" v-if="preferences.cities.length > 1">
        <b-col sm="5" class="form-label">
          <i class="fa fax fa-globe"></i>
          <label>Plaats(en)<br/>(Meerdere mogelijk)</label>
        </b-col>
        <b-col sm="7">
          <multiselect
                  v-model="chosenCities"
                  :options="preferences.cities"
                  :multiple="true"
                  placeholder="Vul in om te zoeken"
                  track-by="text"
                  label="text"
                  selectLabel=""
                  deselectLabel=""
                  @input="checkHoods"
                  selectGroupLabel="Selecteer groep"
                  deselectGroupLabel="Groep uit selectie verwijderen"
                  selectedLabel=""
                  :close-on-select="false"
          >
            <span slot="noResult">Er zijn geen plaatsen gevonden.</span>
          </multiselect>
        </b-col>
      </b-row>

      <template v-for="city in Object.keys(neighborhoods)">
        <b-row v-if="activeNeighborhoods.indexOf(city) > -1" class="multiselect-row" :key="city">
          <b-col sm="5" class="form-label">
            <i class="fa fax fa-globe"></i>
            <label>{{city}} - Wijken</label>
          </b-col>
          <b-col sm="7">
            <PreferencesNeighborhoods
                    :city="city"
                    :neighborhoods="neighborhoods[city].options"
                    :chosen="neighborhoods[city].chosen"
                    @changed="updateNeighborhoods"
            ></PreferencesNeighborhoods>
          </b-col>
        </b-row>
      </template>


<!--      <b-row class="slider-row">
        <b-col sm="5" class="form-label">
          <i class="far fax fa-draw-circle"></i>
          <label>In een straal van</label>
        </b-col>
        <b-col sm="7">
          <vue-slider
                  v-model="preferences.currentSettings.radius"
                  :data="formData.radiusOptions"
                  :marks="true"
                  :tooltip-formatter="val => `${val} KM`"
          ></vue-slider>
        </b-col>
      </b-row>-->

      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fa fax fa-euro-sign"></i>
          <label>Gewenste huurprijs</label>
        </b-col>

        <b-col xs="3">
          <b-input-group class="custom-input-group" prepend="van  €">
            <b-form-input
                    class="rent-input"
                    type="number"
                    min="0"
                    step="1"
                    id="minRent"
                    size="sm"
                    placeholder=""
                    v-model="$v.preferences.currentSettings.rent.min.$model"
                    :state="highlightInvalid ? !$v.preferences.currentSettings.rent.min.$invalid : undefined"
                    required
            />
          </b-input-group>
        </b-col>

        <b-col xs="3">
          <b-input-group class="custom-input-group" prepend="t/m  €">
            <b-form-input
                    class="rent-input"
                    type="number"
                    min="0"
                    step="1"
                    id="maxRent"
                    size="sm"
                    placeholder=""
                    v-model="$v.preferences.currentSettings.rent.max.$model"
                    :state="highlightInvalid ? !$v.preferences.currentSettings.rent.max.$invalid : undefined"
                    required
            />
          </b-input-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fa fax fa-home"></i>
          <label>Type van de woning</label>
        </b-col>
        <b-col sm="7" class="checkbox-column">
          <b-form-group>
            <b-form-checkbox
                    v-for="model in preferences.models"
                    v-model="preferences.currentSettings.models"
                    :key="model.value"
                    :value="model.value"
                    name="models"
            >
              {{ model.text }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="slider-row">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-bed-empty"></i>
          <label>Minimaal aantal kamers</label>
        </b-col>
        <b-col sm="7">
          <vue-slider
                  v-model="preferences.currentSettings.rooms"
                  :adsorb="true"
                  :data="formData.roomOptions"
                  :data-value="'id'"
                  :data-label="'name'"
          ></vue-slider>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
      </b-row>

      <h2>Tip services</h2>
      <b-row>
        <b-col>
          <p>
            U kunt er voor kiezen om Tipberichten te ontvangen. U ontvangt dan maximaal 2 keer per week een e-mail met de geadverteerde woningen die overeenkomen met uw woonwensen en passend zijn bij uw inkomen en gezinssamenstelling. Zie ook bij Veelgestelde vragen en antwoorden.
          </p>
        </b-col>
      </b-row>

      <b-row class="slider-row">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-heart-circle"></i>
          <label>Ik wil getipt worden</label>
        </b-col>
        <b-col sm="7">
          <b-form-radio-group
                  v-model="preferences.currentSettings.tipme"
                  :options="formData.tipme"
                  name="rental"
                  class="radio-group-align-with-label"
          />
        </b-col>
      </b-row>

      <b-row v-if="preferences.currentSettings.tipme">
        <b-col sm="5" class="form-label">
          <i class="fa fax fa-comments"></i>
          <label>Hoe wilt u getipt worden?</label>
        </b-col>
        <b-col sm="7" class="checkbox-column">
          <b-form-group>
            <b-form-checkbox
                    v-for="com in preferences.communication"
                    v-model="preferences.currentSettings.communication"
                    :key="com.value"
                    :value="com.value"
                    :required="preferences.currentSettings.tipme"
                    name="communication"
            >
              {{ com.text }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <br>
      <error-box v-if="postErrors.length > 0" :errors="postErrors"/>

      <FormButtons @next="next" @previous="$emit('previous')"/>
    </template>
    <vuelidateErrorDialog :validator="$v.preferences" :state="errDialogVisible" parent="NAW" @onClose="errDialogVisible = false"/>

  </div>
</template>
<script>
import FormButtons from '@/components/_registration/FormButtons'
import { registrationService } from '@/_services/registration.service'
import FormLoader from '@/components/_registration/FormLoader'
import Multiselect from 'vue-multiselect'
import SubHeader from '@/components/_registration/SubHeader'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { required, requiredIf } from 'vuelidate/lib/validators'
import ErrorBox from '@/components/_registration/ErrorBox'
import PreferencesNeighborhoods from "./PreferencesNeighborhoods";
import { validGUID } from '@/_helpers/validators'
import vuelidateErrorDialog from "@/components/VuelidateErrorDialog";

export default {
  components: { FormButtons, FormLoader, Multiselect, SubHeader, VueSlider, ErrorBox, PreferencesNeighborhoods, vuelidateErrorDialog },
  name: 'Preferences',
  data () {
    return {
      skin: {
        region: process.env.VUE_APP_REGION,
      },
      postErrors: [],
      errDialogVisible: false,
      highlightInvalid: false,
      formData: {
        radiusOptions: [0, 1, 2, 3, 5, 10],
        roomOptions: [
          { id: 1, name: '1' },
          { id: 2, name: '2' },
          { id: 3, name: '3' },
          { id: 4, name: '4' },
          { id: 5, name: '5 of meer' },
        ],
        tipme: [
          { text: 'Ja graag', value: true },
          { text: 'Nee hoor', value: false },
        ],
      },
      loading: false,
      preferences: {
        cities: [],
        models: [],
        communication: [],
        currentSettings: {
          cities: [],
          communication: [],
          models: [],
          rent: {
            min: null,
            max: null
          }
        },
      },
      chosenCities: [],
      neighborhoods: {},
      activeNeighborhoods: []
    }
  },
  validations: {
    preferences: {
      currentSettings: {
        rent: {
          min: { required },
          max: { required }
        },
        communication: {
          required: requiredIf(function(preferences) {
            return this.preferences.currentSettings.tipme
          })
        }
      },
    }
  },
  computed: {
    validated () {
      return !this.$v.$invalid
    }
  },
  watch: {
    validated (val) {
      this.$emit('validated', val)
    },
  },

  mounted () {
    this.fetchData()
    this.$emit('validated', true)
    if(this.$store.state.registration.errors[this.$options.name] !== undefined) {
      this.highlightInvalid = true
    }
  },
  methods: {
    next () {
      this.$v.$touch()
      if (this.validated) {
        this.submit()
      } else {
        this.highlightInvalid = true
        this.errDialogVisible = true
      }
    },

    updateNeighborhoods(args) {
      this.neighborhoods[args.city].chosen = args.choices
    },

    initializeCities(){
      let _this = this
      if(this.preferences.cities.length === 1) {
        this.preferences.cities[0].chosen = true
        _this.chosenCities.push(this.preferences.cities[0])
      } else {
        this.preferences.cities.forEach(function (item, index) {
          if(item.chosen) {
            _this.chosenCities.push(item)
          }
          if(item.children.length) {
            let chosen = []

            _this.neighborhoods[item.value] = {
              chosen: [],
              options: item.children
            }

            _this.neighborhoods[item.value].options.unshift({
              'text': 'Alle Wijken',
              'value': 'all'
            })

            item.children.forEach((child) => {
              if(child.chosen) {
                chosen.push(child)
              }
            })

            if(chosen.length+1 === item.children.length || chosen.length === 0) {
              _this.neighborhoods[item.value].chosen.push({
                'text': 'Alle Wijken',
                'value': 'all'
              })
            } else {
              _this.neighborhoods[item.value].chosen = chosen
            }
            if(chosen.length) {
              _this.activeNeighborhoods.push(item.value)
            }
          }
        })
      }
    },

    checkHoods() {
      let activeHoods = [];
      this.chosenCities.forEach((obj) => {
        if(!validGUID(obj.value)) {
          activeHoods.push(obj.value)
        }
      })
      this.activeNeighborhoods = activeHoods
    },

    fetchData () {
      this.loading = true
      registrationService.getPreferences().then(result => {
        this.preferences = result
        this.initializeCities()
      }).finally(() => {
        this.loading = false
      })
    },

    submit(){
      this.preferences.currentSettings.rent.min = Math.floor(this.preferences.currentSettings.rent.min)
      this.preferences.currentSettings.rent.max = Math.floor(this.preferences.currentSettings.rent.max)

      let data = JSON.parse(JSON.stringify(this.preferences.currentSettings))
      let chosenHoods = []
      data.cities = []

      this.chosenCities.forEach(function (item, index) {
        if(validGUID(item.value)) {
          data.cities.push(item.value)
        } else {
          chosenHoods.push(item.value)
        }
      });

      chosenHoods.forEach((key) => {
        if(this.neighborhoods[key].chosen[0].value === 'all') {
          this.neighborhoods[key].options.forEach((child) => {
            if(validGUID(child.value)) {
              data.cities.push(child.value)
            }
          })
        } else {
          this.neighborhoods[key].chosen.forEach((child) => {
            if(validGUID(child.value)) {
              data.cities.push(child.value)
            }
          })
        }
      })

      registrationService.postPreferences(data).then(result => {
        if ('errors' in result) {
          this.postErrors = result.errors
        } else {
          this.postErrors.errors = []
          this.$emit('next')
        }
      })
    },
  }
}
</script>

<style lang='scss'>

$themeColor: #009e0f;
@import '~vue-slider-component/lib/theme/default.scss';
@import '~vue-multiselect/dist/vue-multiselect.min.css';

.subtitle {
  padding-bottom: 15px
}

@media(max-width: 576px) {
  .form-label {
    margin-bottom: 0;
    margin-top: 20px;
  }
  .slider-row {
    margin-bottom: 20px;
  }
}

@media(min-width: 576px) {
  .slider-row {
    margin-top: 20px;
  }
  .checkbox-column {
    padding-top: 10px;
  }
}

.radio-group-align-with-label {
  padding-top: 6px
}
.rent-input {
  padding-bottom: 0;
  text-align: center;
}
</style>
